import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ArrowBack } from '@mui/icons-material';
import { IconButton } from '@totalsoft/rocket-ui';

const HeaderLinks = ({ onAdd, onClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <IconButton fontSize='medium' color='transparent' tooltip={t('DocumentTypes.BackToList')} onClick={onClose}>
        <ArrowBack />
      </IconButton>
      <IconButton
        type='add'
        fontSize='medium'
        color='transparent'
        tooltip={t('Tooltips.DocumentTypeProperty.AddNewDocumentTypeProperty')}
        onClick={onAdd}
      />
    </>
  );
};
HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export default HeaderLinks;
